import {useMapContext} from '@/components/MindMap/index.mjs'
import _ToolBar from '../ToolBar.jsx'
import MenuButtonDashboard from '../menuButtons/MenuButtonDashboard.jsx'
import MenuButtonAddToFrequentProject from '../menuButtons/MenuButtonAddToFrequentProject.jsx'
import MenuButtonAiGenerateReq from '../menuButtons/MenuButtonAiGenerateReq.jsx'
import MenuButtonSetAsCurrentProject from '../menuButtons/MenuButtonSetAsCurrentProject.jsx'
import MenuButtonAiGenerateSrf from './MenuButtonAiGenerateSrf.jsx'
import MenuButtonAiGenCode from './MenuButtonAiGenCode.jsx'
import MenuButtonAiGenerateReqDoc from './MenuButtonAiGenerateReqDoc.jsx'
import MenuButtonExportDoc from './MenuButtonExportDoc.jsx'
import MenuButtonExportSpec from './MenuButtonExportSpec.jsx'
import MenuButtonWorkload from './MenuButtonWorkload.jsx'

export default function ToolBar(props) {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    return (
        <_ToolBar {...props}>
            <div>
                <MenuButtonDashboard />
            </div>

            <div>
                <MenuButtonAiGenerateReq />
                <MenuButtonAiGenerateSrf />
                <MenuButtonAiGenCode />
                <MenuButtonWorkload />
                <MenuButtonAiGenerateReqDoc />
                <MenuButtonExportSpec />
                <MenuButtonExportDoc />
            </div>

            <div>
                <MenuButtonSetAsCurrentProject />
                <MenuButtonAddToFrequentProject />
            </div>
        </_ToolBar>
    )
}
